import React, { useEffect, useMemo, useState } from 'react'
import api from '../lib/api'

const ENTITY_CONFIG = {
  users: {
    title: 'Usuários',
    endpoint: '/admin/users',
    fields: [
      { name: 'name', label: 'Nome', type: 'text', required: true },
      { name: 'email', label: 'Email', type: 'email', required: true },
      { name: 'password', label: 'Senha', type: 'password' },
      { name: 'userType', label: 'Perfil', type: 'select', options: ['student', 'parent', 'teacher', 'professional', 'admin'], required: true },
      { name: 'phone', label: 'Telefone', type: 'text' },
      { name: 'city', label: 'Cidade', type: 'text' },
      { name: 'state', label: 'Estado', type: 'text' },
      { name: 'country', label: 'País', type: 'text' },
      { name: 'bio', label: 'Bio', type: 'textarea' },
      { name: 'avatarUrl', label: 'Avatar URL', type: 'text' },
      { name: 'isActive', label: 'Ativo', type: 'checkbox' },
      { name: 'emailVerified', label: 'Email verificado', type: 'checkbox' }
    ],
    defaults: { userType: 'student', isActive: true, emailVerified: false }
  },
  plans: {
    title: 'Planos',
    endpoint: '/admin/plans',
    fields: [
      { name: 'slug', label: 'Slug', type: 'text', required: true },
      { name: 'name', label: 'Nome', type: 'text', required: true },
      { name: 'description', label: 'Descrição', type: 'textarea' },
      { name: 'price', label: 'Preço', type: 'number' },
      { name: 'currency', label: 'Moeda', type: 'text' },
      { name: 'maxActivities', label: 'Máx. atividades', type: 'number' },
      { name: 'maxGames', label: 'Máx. games', type: 'number' },
      { name: 'maxBlockly', label: 'Máx. blocos', type: 'number' },
      { name: 'displayOrder', label: 'Ordem', type: 'number' },
      { name: 'hasAi', label: 'IA', type: 'checkbox' },
      { name: 'hasProfessionals', label: 'Profissionais', type: 'checkbox' },
      { name: 'hasVideoCall', label: 'Videochamada', type: 'checkbox' },
      { name: 'isActive', label: 'Ativo', type: 'checkbox' }
    ],
    defaults: { currency: 'BRL', price: 0, maxActivities: 0, maxGames: 0, maxBlockly: 0, displayOrder: 0, hasAi: false, hasProfessionals: false, hasVideoCall: false, isActive: true }
  },
  activities: {
    title: 'Atividades',
    endpoint: '/admin/activities',
    fields: [
      { name: 'title', label: 'Título', type: 'text', required: true },
      { name: 'description', label: 'Descrição', type: 'textarea' },
      { name: 'type', label: 'Tipo', type: 'select', options: ['practice', 'game', 'blockly'], required: true },
      { name: 'category', label: 'Categoria', type: 'text' },
      { name: 'subcategory', label: 'Subcategoria', type: 'text' },
      { name: 'grade', label: 'Série', type: 'number' },
      { name: 'difficulty', label: 'Dificuldade', type: 'select', options: ['easy', 'medium', 'hard'] },
      { name: 'accessLevel', label: 'Acesso', type: 'select', options: ['free', 'basic', 'regular', 'premium'] },
      { name: 'durationMinutes', label: 'Duração', type: 'number' },
      { name: 'estimatedScore', label: 'Pontuação', type: 'number' },
      { name: 'orderIndex', label: 'Ordem', type: 'number' },
      { name: 'imageUrl', label: 'Imagem URL', type: 'text' },
      { name: 'videoUrl', label: 'Vídeo URL', type: 'text' },
      { name: 'content', label: 'JSON de conteúdo', type: 'json' },
      { name: 'isActive', label: 'Ativo', type: 'checkbox' }
    ],
    defaults: { type: 'practice', accessLevel: 'free', content: '{}', isActive: true }
  },
  professionals: {
    title: 'Profissionais',
    endpoint: '/admin/professionals',
    fields: [
      { name: 'userId', label: 'Usuário', type: 'select', optionsKey: 'users', required: true },
      { name: 'specialty', label: 'Especialidade', type: 'text', required: true },
      { name: 'specialization', label: 'Especialização', type: 'text' },
      { name: 'bio', label: 'Bio', type: 'textarea' },
      { name: 'credentials', label: 'Credenciais', type: 'textarea' },
      { name: 'licenseNumber', label: 'Registro', type: 'text' },
      { name: 'rating', label: 'Avaliação', type: 'number' },
      { name: 'reviewsCount', label: 'Qtd. reviews', type: 'number' },
      { name: 'hourlyRate', label: 'Valor/hora', type: 'number' },
      { name: 'availabilityJson', label: 'Disponibilidade JSON', type: 'json' },
      { name: 'serviceFocusJson', label: 'Foco JSON', type: 'json' },
      { name: 'onlineSupport', label: 'Atendimento online', type: 'checkbox' },
      { name: 'verified', label: 'Verificado', type: 'checkbox' },
      { name: 'isActive', label: 'Ativo', type: 'checkbox' }
    ],
    defaults: { availabilityJson: '{"days":[]}', serviceFocusJson: '{"supports":[],"focus":[]}', onlineSupport: true, verified: false, isActive: true }
  },
  subscriptions: {
    title: 'Assinaturas',
    endpoint: '/admin/subscriptions',
    fields: [
      { name: 'userId', label: 'Usuário', type: 'select', optionsKey: 'users', required: true },
      { name: 'planId', label: 'Plano', type: 'select', optionsKey: 'plans', required: true },
      { name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive', 'cancelled', 'expired', 'pending'] },
      { name: 'startDate', label: 'Início', type: 'datetime-local' },
      { name: 'endDate', label: 'Fim', type: 'datetime-local' },
      { name: 'nextBillingDate', label: 'Próx. cobrança', type: 'datetime-local' },
      { name: 'cancelledAt', label: 'Cancelado em', type: 'datetime-local' },
      { name: 'cancellationReason', label: 'Motivo cancelamento', type: 'textarea' },
      { name: 'autoRenewal', label: 'Renovação automática', type: 'checkbox' }
    ],
    defaults: { status: 'pending', autoRenewal: true }
  },
  payments: {
    title: 'Pagamentos',
    endpoint: '/admin/payments',
    fields: [
      { name: 'subscriptionId', label: 'Assinatura', type: 'select', optionsKey: 'subscriptions', allowEmpty: true },
      { name: 'userId', label: 'Usuário', type: 'select', optionsKey: 'users', required: true },
      { name: 'mercadopagoPaymentId', label: 'MP Payment ID', type: 'text' },
      { name: 'mercadopagoPreferenceId', label: 'MP Preference ID', type: 'text' },
      { name: 'amount', label: 'Valor', type: 'number', required: true },
      { name: 'currency', label: 'Moeda', type: 'text' },
      { name: 'status', label: 'Status', type: 'select', options: ['pending', 'approved', 'rejected', 'cancelled', 'refunded'] },
      { name: 'paymentMethod', label: 'Método', type: 'text' },
      { name: 'paymentType', label: 'Tipo pagamento', type: 'text' },
      { name: 'externalReference', label: 'Referência externa', type: 'text' },
      { name: 'payerEmail', label: 'Email pagador', type: 'email' },
      { name: 'payerName', label: 'Nome pagador', type: 'text' },
      { name: 'transactionAmount', label: 'Valor transação', type: 'number' },
      { name: 'netReceivedAmount', label: 'Líquido recebido', type: 'number' },
      { name: 'feeAmount', label: 'Taxa', type: 'number' },
      { name: 'installments', label: 'Parcelas', type: 'number' },
      { name: 'description', label: 'Descrição', type: 'textarea' },
      { name: 'errorMessage', label: 'Mensagem erro', type: 'textarea' }
    ],
    defaults: { currency: 'BRL', status: 'pending', installments: 1 }
  },
  appointments: {
    title: 'Atendimentos',
    endpoint: '/admin/appointments',
    fields: [
      { name: 'userId', label: 'Usuário', type: 'select', optionsKey: 'users', required: true },
      { name: 'professionalId', label: 'Profissional', type: 'select', optionsKey: 'professionals', required: true },
      { name: 'appointmentDate', label: 'Data', type: 'date', required: true },
      { name: 'appointmentTime', label: 'Hora', type: 'time', required: true },
      { name: 'durationMinutes', label: 'Tempo máximo da sessão (min)', type: 'number' },
      { name: 'status', label: 'Status', type: 'select', options: ['scheduled', 'confirmed', 'cancelled', 'completed'] },
      { name: 'serviceType', label: 'Serviço', type: 'select', options: ['anamnese', 'orientacao', 'avaliacao', 'acompanhamento'] },
      { name: 'modality', label: 'Modalidade', type: 'select', options: ['online', 'presencial', 'hibrido'] },
      { name: 'notes', label: 'Observações', type: 'textarea' },
      { name: 'studentProfileJson', label: 'Perfil aluno JSON', type: 'json' },
      { name: 'intakeFormJson', label: 'Anamnese JSON', type: 'json' },
      { name: 'videoCallLink', label: 'Link de videochamada', type: 'text' },
      { name: 'meetingId', label: 'Meeting ID', type: 'text' },
      { name: 'cancellationReason', label: 'Motivo cancelamento', type: 'text' },
      { name: 'completedAt', label: 'Concluído em', type: 'datetime-local' },
      { name: 'rating', label: 'Avaliação', type: 'number' },
      { name: 'review', label: 'Review', type: 'textarea' }
    ],
    defaults: { durationMinutes: 60, status: 'scheduled', serviceType: 'anamnese', modality: 'online', studentProfileJson: '{}', intakeFormJson: '{}' }
  },
  bncc: {
    title: 'BNCC',
    endpoint: '/admin/bncc-skills',
    fields: [
      { name: 'grade', label: 'Série', type: 'number', required: true },
      { name: 'subject', label: 'Disciplina', type: 'text' },
      { name: 'unitTheme', label: 'Unidade temática', type: 'text', required: true },
      { name: 'competenceTitle', label: 'Competência', type: 'textarea' },
      { name: 'skillTitle', label: 'Habilidade', type: 'textarea', required: true },
      { name: 'skillReference', label: 'Referência', type: 'text' },
      { name: 'learningObjectives', label: 'Objetivos', type: 'textarea' }
    ],
    defaults: { subject: 'Matemática' }
  },
  modules: {
    title: 'Módulos BNCC',
    endpoint: '/admin/learning-modules',
    fields: [
      { name: 'bnccSkillId', label: 'Habilidade BNCC', type: 'select', optionsKey: 'skills', allowEmpty: true },
      { name: 'title', label: 'Título', type: 'text', required: true },
      { name: 'slug', label: 'Slug', type: 'text', required: true },
      { name: 'grade', label: 'Série', type: 'number', required: true },
      { name: 'subject', label: 'Disciplina', type: 'text' },
      { name: 'topic', label: 'Tópico', type: 'text', required: true },
      { name: 'dimension', label: 'Dimensão', type: 'select', options: ['regular', 'adapted', 'blocks', 'games'], required: true },
      { name: 'methodology', label: 'Metodologia', type: 'text' },
      { name: 'summary', label: 'Resumo', type: 'textarea' },
      { name: 'teacherNotes', label: 'Notas do professor', type: 'textarea' },
      { name: 'estimatedMinutes', label: 'Tempo estimado', type: 'number' },
      { name: 'createdByUserId', label: 'Criado por', type: 'select', optionsKey: 'users', allowEmpty: true },
      { name: 'isGenerated', label: 'Gerado por IA', type: 'checkbox' },
      { name: 'isActive', label: 'Ativo', type: 'checkbox' }
    ],
    defaults: { subject: 'Matemática', dimension: 'regular', estimatedMinutes: 45, isGenerated: false, isActive: true }
  },
  exercises: {
    title: 'Exercícios',
    endpoint: '/admin/module-exercises',
    fields: [
      { name: 'moduleId', label: 'Módulo', type: 'select', optionsKey: 'modules', required: true },
      { name: 'exerciseNumber', label: 'Número', type: 'number', required: true },
      { name: 'title', label: 'Título', type: 'text', required: true },
      { name: 'prompt', label: 'Enunciado', type: 'textarea', required: true },
      { name: 'expectedAnswer', label: 'Resposta esperada', type: 'text' },
      { name: 'supportStrategy', label: 'Estratégia suporte', type: 'textarea' },
      { name: 'regularSolution', label: 'Solução regular', type: 'textarea' },
      { name: 'alternativeSolution', label: 'Solução alternativa', type: 'textarea' },
      { name: 'blocksSolution', label: 'Solução blocos', type: 'textarea' },
      { name: 'gameChallenge', label: 'Desafio game', type: 'textarea' },
      { name: 'starterCode', label: 'Starter code', type: 'textarea' },
      { name: 'answerPattern', label: 'Padrão resposta', type: 'text' }
    ],
    defaults: { exerciseNumber: 1 }
  },
  rooms: {
    title: 'Salas de chat',
    endpoint: '/admin/support-rooms',
    fields: [
      { name: 'userId', label: 'Usuário', type: 'select', optionsKey: 'users', required: true },
      { name: 'professionalId', label: 'Profissional', type: 'select', optionsKey: 'professionals', allowEmpty: true },
      { name: 'title', label: 'Título', type: 'text', required: true },
      { name: 'status', label: 'Status', type: 'select', options: ['open', 'waiting', 'closed'] },
      { name: 'preQuestionnaireJson', label: 'Questionário JSON', type: 'json' },
      { name: 'anamnesisRequired', label: 'Anamnese obrigatória', type: 'checkbox' }
    ],
    defaults: { status: 'open', preQuestionnaireJson: '{}', anamnesisRequired: false }
  }
}

function deriveOptions(options = {}) {
  return {
    users: (options.users || []).map((item) => ({ value: String(item.id), label: `${item.name} • ${item.email}` })),
    plans: (options.plans || []).map((item) => ({ value: String(item.id), label: `${item.name} (${item.slug})` })),
    professionals: (options.professionals || []).map((item) => ({ value: String(item.id), label: `${item.name || item.userName || item.id} • ${item.specialty}` })),
    subscriptions: (options.subscriptions || []).map((item) => ({ value: String(item.id), label: `#${item.id} • usuário ${item.userId} • plano ${item.planId}` })),
    skills: (options.skills || []).map((item) => ({ value: String(item.id), label: `${item.grade}º ano • ${item.skillTitle}` })),
    modules: (options.modules || []).map((item) => ({ value: String(item.id), label: `${item.title} • ${item.dimension}` })),
    rooms: (options.rooms || []).map((item) => ({ value: String(item.id), label: `#${item.id} • ${item.title}` }))
  }
}

function formatJson(value) {
  if (value === null || value === undefined || value === '') return '{}'
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return '{}'
  }
}

function normalizeForForm(entity, item) {
  const defaults = ENTITY_CONFIG[entity].defaults || {}
  const normalized = { ...defaults, ...item }
  Object.keys(normalized).forEach((key) => {
    if (key.toLowerCase().includes('json') || key === 'content') normalized[key] = formatJson(normalized[key])
  })
  return normalized
}

function normalizeForApi(config, form) {
  const payload = {}
  config.fields.forEach((field) => {
    if (field.type === 'checkbox') payload[field.name] = Boolean(form[field.name])
    else payload[field.name] = form[field.name] ?? ''
  })
  return payload
}

function EntityForm({ entityKey, form, setForm, options }) {
  const config = ENTITY_CONFIG[entityKey]
  return (
    <div className="surface-card">
      <div className="section-head">
        <div>
          <h3>Editor de {config.title}</h3>
          <p>Crie, revise e atualize registros reais do portal.</p>
        </div>
      </div>
      <div className="grid cols-2">
        {config.fields.map((field) => {
          const value = form[field.name] ?? (field.type === 'checkbox' ? false : '')
          const optionList = field.optionsKey ? (options[field.optionsKey] || []) : (field.options || []).map((item) => ({ value: item, label: item }))
          return (
            <label key={field.name} className="form-label">
              {field.label}
              {field.type === 'textarea' || field.type === 'json' ? (
                <textarea
                  className="input textarea"
                  value={value}
                  onChange={(event) => setForm((current) => ({ ...current, [field.name]: event.target.value }))}
                />
              ) : field.type === 'checkbox' ? (
                <div style={{ marginTop: 10 }}>
                  <input
                    type="checkbox"
                    checked={Boolean(value)}
                    onChange={(event) => setForm((current) => ({ ...current, [field.name]: event.target.checked }))}
                  />
                </div>
              ) : field.type === 'select' ? (
                <select
                  className="input"
                  value={value === null || value === undefined ? '' : String(value)}
                  onChange={(event) => setForm((current) => ({ ...current, [field.name]: event.target.value }))}
                >
                  {field.allowEmpty ? <option value="">Selecione</option> : null}
                  {optionList.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
                </select>
              ) : (
                <input
                  className="input"
                  type={field.type || 'text'}
                  value={value}
                  onChange={(event) => setForm((current) => ({ ...current, [field.name]: event.target.value }))}
                />
              )}
            </label>
          )
        })}
      </div>
    </div>
  )
}

function EntityTable({ items, onEdit, onDelete }) {
  if (!items.length) return <div className="alert">Nenhum registro encontrado nesta aba.</div>
  const columns = Object.keys(items[0]).slice(0, 6)
  return (
    <div className="surface-card">
      <div className="section-head">
        <div>
          <h3>Registros</h3>
          <p>Selecione um item para editar ou remova quando necessário.</p>
        </div>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {columns.map((column) => <th key={column} style={{ textAlign: 'left', padding: '10px 8px', borderBottom: '1px solid var(--line)' }}>{column}</th>)}
              <th style={{ textAlign: 'left', padding: '10px 8px', borderBottom: '1px solid var(--line)' }}>ações</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                {columns.map((column) => <td key={column} style={{ padding: '10px 8px', borderBottom: '1px solid #edf2f7', color: 'var(--muted)' }}>{String(item[column] ?? '').slice(0, 90)}</td>)}
                <td style={{ padding: '10px 8px', borderBottom: '1px solid #edf2f7' }}>
                  <div className="button-wrap">
                    <button className="btn btn-secondary" onClick={() => onEdit(item)}>Editar</button>
                    <button className="btn btn-danger" onClick={() => onDelete(item)}>Excluir</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

function MessageManager({ roomId }) {
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!roomId) return
    const fetchMessages = async () => {
      try {
        setLoading(true)
        const { data } = await api.get(`/admin/support-rooms/${roomId}/messages`)
        setMessages(data.items || [])
      } catch (err) {
        setError(err.response?.data?.error || 'Não foi possível carregar as mensagens da sala.')
      } finally {
        setLoading(false)
      }
    }
    fetchMessages()
  }, [roomId])

  const handleSend = async () => {
    if (!message.trim()) return
    try {
      const { data } = await api.post(`/admin/support-rooms/${roomId}/messages`, { senderRole: 'admin', message })
      setMessages((current) => [...current, data.item])
      setMessage('')
      setError('')
    } catch (err) {
      setError(err.response?.data?.error || 'Não foi possível enviar a mensagem admin.')
    }
  }

  if (!roomId) return null
  return (
    <div className="surface-card">
      <div className="section-head">
        <div>
          <h3>Mensagens da sala #{roomId}</h3>
          <p>Atenda o usuário sem sair do painel.</p>
        </div>
      </div>
      {loading ? <div className="loading-box">Carregando mensagens...</div> : null}
      {error ? <div className="alert" style={{ marginBottom: 12 }}>{error}</div> : null}
      <div className="stack-sm" style={{ maxHeight: 320, overflow: 'auto', marginBottom: 16 }}>
        {messages.map((item) => (
          <div key={item.id} className="surface-card compact" style={{ background: item.senderRole === 'admin' ? '#eff6ff' : 'white' }}>
            <strong>{item.senderRole}</strong>
            <p style={{ margin: '6px 0 0' }}>{item.message}</p>
          </div>
        ))}
      </div>
      <div className="grid cols-2">
        <textarea className="input textarea" value={message} onChange={(event) => setMessage(event.target.value)} placeholder="Digite a resposta do administrador" />
        <div className="button-wrap" style={{ alignItems: 'flex-start' }}>
          <button className="btn btn-primary" onClick={handleSend}>Responder na sala</button>
        </div>
      </div>
    </div>
  )
}

export default function AdminOperationsPage() {
  const [entity, setEntity] = useState('users')
  const [items, setItems] = useState([])
  const [options, setOptions] = useState({})
  const [overview, setOverview] = useState(null)
  const [form, setForm] = useState(normalizeForForm('users', {}))
  const [editingId, setEditingId] = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [search, setSearch] = useState('')
  const [selectedRoomId, setSelectedRoomId] = useState(null)

  const optionMaps = useMemo(() => deriveOptions(options), [options])

  const resetForm = (entityKey = entity) => {
    setEditingId(null)
    setForm(normalizeForForm(entityKey, {}))
  }

  const loadStatic = async () => {
    const [overviewResponse, optionsResponse] = await Promise.all([
      api.get('/admin/overview'),
      api.get('/admin/options')
    ])
    setOverview(overviewResponse.data)
    setOptions(optionsResponse.data)
  }

  const loadItems = async (entityKey = entity, currentSearch = search) => {
    setLoading(true)
    try {
      const config = ENTITY_CONFIG[entityKey]
      const { data } = await api.get(config.endpoint, { params: currentSearch ? { search: currentSearch } : {} })
      setItems(data.items || [])
      setError('')
    } catch (err) {
      setError(err.response?.data?.error || 'Falha ao carregar os dados da área admin.')
      setItems([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const bootstrap = async () => {
      try {
        await loadStatic()
      } catch (err) {
        setError(err.response?.data?.error || 'Falha ao carregar opções do painel admin.')
      }
    }
    bootstrap()
  }, [])

  useEffect(() => {
    resetForm(entity)
    loadItems(entity)
    setSelectedRoomId(null)
  }, [entity])

  const handleEdit = (item) => {
    setEditingId(item.id)
    setForm(normalizeForForm(entity, item))
    if (entity === 'rooms') setSelectedRoomId(item.id)
  }

  const handleDelete = async (item) => {
    const confirmed = window.confirm(`Deseja realmente excluir #${item.id}?`)
    if (!confirmed) return
    try {
      await api.delete(`${ENTITY_CONFIG[entity].endpoint}/${item.id}`)
      setSuccess('Registro removido com sucesso.')
      await Promise.all([loadItems(entity), loadStatic()])
      if (editingId === item.id) resetForm(entity)
    } catch (err) {
      setError(err.response?.data?.error || 'Não foi possível excluir o registro.')
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSaving(true)
    setError('')
    setSuccess('')
    try {
      const config = ENTITY_CONFIG[entity]
      const payload = normalizeForApi(config, form)
      if (editingId) {
        await api.put(`${config.endpoint}/${editingId}`, payload)
        setSuccess('Registro atualizado com sucesso.')
      } else {
        await api.post(config.endpoint, payload)
        setSuccess('Registro criado com sucesso.')
      }
      await Promise.all([loadItems(entity), loadStatic()])
      resetForm(entity)
    } catch (err) {
      setError(err.response?.data?.error || 'Falha ao salvar o registro.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="page-stack">
      <section className="hero-panel">
        <div className="section-title-wrap">
          <span className="eyebrow">admin operacional completo</span>
          <h1>CRUD real do portal inteiro.</h1>
          <p>Usuários, planos, assinaturas, pagamentos, BNCC, módulos, exercícios, atividades, profissionais, atendimentos e salas de suporte no mesmo lugar.</p>
          <div className="button-wrap">
            <button className="btn btn-primary" onClick={() => loadItems(entity, search)}>Atualizar lista</button>
            <button className="btn btn-secondary" onClick={() => { resetForm(entity); setSuccess(''); setError('') }}>Novo registro</button>
          </div>
        </div>
        <div className="hero-stats-grid">
          <div className="stat-block"><span>Usuários</span><strong>{overview?.users?.total ?? '-'}</strong></div>
          <div className="stat-block"><span>Atividades</span><strong>{overview?.activities?.total ?? '-'}</strong></div>
          <div className="stat-block"><span>Assinaturas ativas</span><strong>{overview?.subscriptions?.active ?? '-'}</strong></div>
          <div className="stat-block"><span>Salas abertas</span><strong>{overview?.supportRooms?.openRooms ?? '-'}</strong></div>
        </div>
      </section>

      <section className="surface-card">
        <div className="section-head">
          <div>
            <h2>Áreas do administrador</h2>
            <p>Troque de aba e faça a manutenção completa sem mexer direto no banco.</p>
          </div>
          <div className="button-wrap">
            <input className="input" placeholder="Buscar nesta aba" value={search} onChange={(event) => setSearch(event.target.value)} style={{ minWidth: 220 }} />
            <button className="btn btn-ghost" onClick={() => loadItems(entity, search)}>Pesquisar</button>
          </div>
        </div>
        <div className="tag-cloud">
          {Object.entries(ENTITY_CONFIG).map(([key, config]) => (
            <button key={key} className={`chip ${entity === key ? 'chip-active' : ''}`} onClick={() => setEntity(key)}>{config.title}</button>
          ))}
        </div>
      </section>

      {error ? <div className="alert">{error}</div> : null}
      {success ? <div className="alert" style={{ background: '#ecfdf5', borderColor: '#bbf7d0', color: '#166534' }}>{success}</div> : null}

      <form className="section-stack" onSubmit={handleSubmit}>
        <EntityForm entityKey={entity} form={form} setForm={setForm} options={optionMaps} />
        <div className="button-wrap">
          <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Salvando...' : editingId ? 'Salvar alterações' : 'Criar registro'}</button>
          {editingId ? <button className="btn btn-secondary" type="button" onClick={() => resetForm(entity)}>Cancelar edição</button> : null}
        </div>
      </form>

      {loading ? <div className="loading-box">Carregando registros...</div> : <EntityTable items={items} onEdit={handleEdit} onDelete={handleDelete} />}

      {entity === 'rooms' ? <MessageManager roomId={selectedRoomId} /> : null}
    </div>
  )
}
